import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-cream py-20 sm:py-28" aria-labelledby="faq-title" data-id="element-45">
      <div className="mx-auto max-w-3xl px-5" data-id="element-46">
        <h2 id="faq-title" className="text-center font-serif text-3xl font-semibold text-ink sm:text-4xl" data-id="element-47">
          Preguntas frecuentes
        </h2>

        <div className="mt-10 space-y-3" data-id="element-48">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={i} className="overflow-hidden rounded-2xl border border-sage/25 bg-white" data-id="element-49">
                <h3 data-id="element-50">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left" data-id="element-51">
                    <span className="font-semibold text-ink" data-id="element-52">{faq.q}</span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-sage-deep transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-53" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-54">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-55">
                      <p className="px-5 pb-5 text-[15px] leading-relaxed text-ink/75" data-id="element-56">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}